export const versionListConstants = {
  VERSION_LIST_LOADING: "VERSION_LIST_LOADING",
  VERSION_LIST_SUCCESS: "VERSION_LIST_SUCCESS",
  VERSION_LIST_FAILURE: "VERSION_LIST_FAILURE",
};

export const versionUploadConstants = {
  VERSION_UPLOAD_LOADING: "VERSION_UPLOAD_LOADING",
  VERSION_UPLOAD_SUCCESS: "VERSION_UPLOAD_SUCCESS",
  VERSION_UPLOAD_FAILURE: "VERSION_UPLOAD_FAILURE",
};
